import type { UserSearchHit } from '@citibox-panel/api-client';

// One phone identifies one «Usuario». When a phone unexpectedly resolves to more
// than one, the winner is picked deterministically: active recipients first,
// original order otherwise preserved (Array.prototype.sort is stable since ES2019),
// so the same payload always opens the same «Usuario». Shared by the phone search
// (which opens the tab) and the ficha (which re-resolves the account from the same hits).
export const firstActiveRecipient = (hits: UserSearchHit[]): UserSearchHit | undefined =>
  [...hits].sort((a, b) => Number(b.active) - Number(a.active))[0];
